module.exports = __webpack_public_path__ + "media/fonts/Roboto-LightItalic-f3afeb2d078386350b6657727c8de98e.ttf";